import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1 text-xs text-foreground-500">
      <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1">
          <i className="ri-arrow-right-s-line text-foreground-400"></i>
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}